import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d96064e")

_pushScopeId("data-v-4d96064e")
const _hoisted_1 = {
  key: 1,
  class: "color-white mt2"
}
const _hoisted_2 = { class: "funteamclues__words-clue-value" }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { class: "funteamclues__words-clue-value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FunTeamCluesGiveClue = _resolveComponent("FunTeamCluesGiveClue")!

  return (_openBlock(), _createBlock("div", {
    class: ["flex flex-column items-center funteamclues__words", {
      blocked: _ctx.gameEnded
    }]
  }, [
    (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (i) => {
      return _createVNode("div", {
        key: `row_${i}`,
        class: "flex funteamclues__words-row justify-center"
      }, [
        (_openBlock(), _createBlock(_Fragment, null, _renderList(5, (j) => {
          return _createVNode("div", {
            key: `item_${j}`,
            class: ["flex items-center justify-center center funteamclues__words-item", {
          'funteamclues__words-item--blue':
            _ctx.currentPlayerInTeam.isSpy && _ctx.words[i * 5 - j].belongsTo === 'BLUE',
          'funteamclues__words-item--red':
            _ctx.currentPlayerInTeam.isSpy && _ctx.words[i * 5 - j].belongsTo === 'RED',
          'funteamclues__words-item--killer':
            _ctx.currentPlayerInTeam.isSpy && _ctx.words[i * 5 - j].belongsTo === 'KILLER',
          'funteamclues__words-item--blue-selected':
            _ctx.words[i * 5 - j].selected && _ctx.words[i * 5 - j].belongsTo === 'BLUE',
          'funteamclues__words-item--red-selected':
            _ctx.words[i * 5 - j].selected && _ctx.words[i * 5 - j].belongsTo === 'RED',
          'funteamclues__words-item--killer-selected':
            _ctx.words[i * 5 - j].selected && _ctx.words[i * 5 - j].belongsTo === 'KILLER',
          'funteamclues__words-item--neutral-selected':
            _ctx.words[i * 5 - j].selected && !_ctx.words[i * 5 - j].belongsTo,
          'funteamclues__words-item--clickable':
            _ctx.phase === 'GUESSING' &&
            !_ctx.currentPlayerInTeam.isSpy &&
            _ctx.currentPlayerInTeam.team === _ctx.activeTeamName &&
            !_ctx.words[i * 5 - j].selected &&
            _ctx.clueNumberOfGuesses > 0
        }],
            onClick: ($event: any) => (_ctx.handleGuessWord(_ctx.words[i * 5 - j]))
          }, [
            _createTextVNode(_toDisplayString(_ctx.words[i * 5 - j].label) + " ", 1),
            (_ctx.words[i * 5 - j].selected)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: "funteamclues__words-item-checkmark",
                  src: 
            require(`@/assets/images/check-circle${
              _ctx.words[i * 5 - j].belongsTo === 'KILLER' ? '-white' : ''
            }.svg`)
          ,
                  alt: "checkmark"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ], 10, ["onClick"])
        }), 64))
      ])
    }), 64)),
    (
        !_ctx.gameEnded &&
        _ctx.phase === 'GIVE_CLUE' &&
        _ctx.currentPlayerInTeam.isSpy &&
        _ctx.currentPlayerInTeam.team === _ctx.activeTeamName
      )
      ? (_openBlock(), _createBlock(_component_FunTeamCluesGiveClue, {
          key: 0,
          onGiveClue: _ctx.handleGiveClue
        }, null, 8, ["onGiveClue"]))
      : _createCommentVNode("", true),
    (_ctx.clue)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.$t('funTeamClues.clue')) + ": ", 1),
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.clue), 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('funTeamClues.numberToGuess')) + ": ", 1),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.clueNumberOfGuesses), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
})